<template>
    <div class="white-box md:rounded-t-lg md:mt-5">
        <Title
            :text="$route.meta.pageTitle"
            style-code-page
            class="text-center md:text-left mt-5 mb-4 md:mt-0 md:mb-3"
        />
        <h4 class="text-gray-900 pb-[0.9375rem] border-b font-normal">
            即日起線上保單服務皆會發送動態密碼予您，並驗證您輸入的動態密碼正確後，才完成線上保單服務申請。
        </h4>
        <h4 class="mt-3.5 mb-2.5">
            請確認您的行動電話及電子信箱
        </h4>
        <p class="text-error mb-2.5">
            我們將使用行動電話發送動態密碼進行交易確認，請您確認資料是否正確。
        </p>

        <!-- personalBox -->
        <div class="border border-gray-200 rounded-md divide-y divide-dashed divide-gray-200 mb-8 text-base md:text-lg">
            <div class="h3 text-gray-900 px-5 py-2.5 flex items-baseline">
                <div class="font-black md:font-normal md:mr-5 w-20 flex-shrink-0">
                    行動電話
                </div>
                <transition
                    name="opacity"
                    mode="out-in"
                >
                    <p
                        v-if="!visiblePopup"
                        class="text-base xs:text-lg"
                    >
                        <span class="break-all">{{ mobile }}</span>
                    </p>
                </transition>
            </div>
            <div class="h3 text-gray-900 px-5 py-2.5 flex items-baseline">
                <div class="font-black md:font-normal md:mr-5 w-20 flex-shrink-0">
                    E-mail
                </div>
                <transition
                    name="opacity"
                    mode="out-in"
                >
                    <p
                        v-if="!visiblePopup"
                        class="text-base xs:text-lg break-all"
                    >
                        <span class="break-all">{{ email }}</span>
                    </p>
                </transition>
            </div>
        </div>

        <div
            v-if="!isStopChange"
            class="flex justify-center"
        >
            <button
                :disabled="isDisabled"
                class="btn btn-accent rounded-full mr-4 xs:mr-5 md:mr-7"
                @click="addBCService()"
            >
                我要變更
            </button>
            <button
                class="btn gradient-primary border-0 rounded-full"
                @click="saveAndgoNext"
            >
                確定
            </button>
        </div>
        <PopupEffect v-model:visiblePopup="visiblePopup" />
    </div>
</template>

<script>
import { ref, computed, reactive, toRefs } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import PopupEffect from '@/components/dialogs/PopupEffect.vue';
import Title from '@/components/text/Title.vue';
import { getContactInfo, startTransaction } from '@/apis/system';
import aplCatlCode from '@/json/aplCatlCode';
import addService from '@/utils/changeItems/addService';
import routeName from '@/router/constant.js';

export default {
    name: 'CheckTelAndMail',
    components: {
        PopupEffect,
        Title,
    },
    setup() {
        const store = useStore();
        const router = useRouter();
        const visiblePopup = ref(true);
        const isLoading = ref(false);
        const isStopChange = ref(false);
        const contactInfo = reactive({
            email: '',
            mobile: ''
        });
        const serviceList = computed(() => store.state.services.serviceList);
        const menuItems = computed(() => store.state.services.transactionItems);
        const aplCatl = computed(() => store.state.services.aplCatl);
        // BC不能被選取變更時
        const isDisabled = computed(() => {
            const a = menuItems.value.filter(i => i.transactionItemNo === 'BC' && i.disabled);
            return a.length > 0;
        });
        const getInfo = () => {
            isLoading.value = true;
            getContactInfo().then((res) => {
                const { email, mobile } = res.data;
                contactInfo.email = email;
                contactInfo.mobile = mobile;
            }).catch(() => {
                // 交易無法進行
                isStopChange.value = true;
            }).finally(() => {
                isLoading.value = false;
            });
        };
        getInfo();

        const addBCService = async () => {
            isLoading.value = true;
            let isOK = true;
            if (aplCatl.value === aplCatlCode.POLICY) {
                const { isNext } = await addService(['BC']);
                isOK = isNext;
            }
            if (isOK) {
                saveAndgoNext();
            } else {
                isLoading.value = false;
            }
        };
        const saveAndgoNext = () => {
            isLoading.value = true;
            startTransaction().then(() => {
                // 如果只有填寫問卷 serviceList.value 為空陣列
                const nextRoute = serviceList.value.length > 0 ? serviceList.value[0].routeName : routeName.CONFIRM_DATA;
                router.push({ name: nextRoute }).catch(error => { console.log(error); });
            }).finally(() => {
                isLoading.value = false;
            });
        };
        return {
            isStopChange,
            visiblePopup,
            addBCService,
            saveAndgoNext,
            isLoading,
            isDisabled,
            ...toRefs(contactInfo)
        };
    },
};
</script>
